/**
 * Environment Configuration
 *
 * Centralized configuration for all environment-specific values.
 * Uses environment variables with sensible defaults for development.
 *
 * Usage:
 *   import { API_BASE_URL, API_TIMEOUT } from '@/config/environment';
 */

// API Configuration
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api/v2';
export const API_TIMEOUT = Number(process.env.REACT_APP_API_TIMEOUT) || 30000;

// Third-party keys
export const TINYMCE_API_KEY = process.env.REACT_APP_TINYMCE_KEY || '';

// Authentication
export const AUTH_TOKEN_KEY = 'authToken';
export const AUTH_USER_KEY = 'user';

// Feature Flags
export const ENABLE_DEBUG_LOGGING = process.env.NODE_ENV === 'development';

// Export as object for cases where destructuring isn't preferred
const config = {
  API_BASE_URL,
  API_TIMEOUT,
  AUTH_TOKEN_KEY,
  AUTH_USER_KEY,
  ENABLE_DEBUG_LOGGING,
};

export default config;
